export default __webpack_public_path__ + "static/the-beam-265be42773a3ec85a3ba9792a46c092e.jpg";